import { render } from "./Lawyer.vue?vue&type=template&id=4dad68e0"
import script from "./Lawyer.vue?vue&type=script&lang=js"
export * from "./Lawyer.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__